import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Textarea } from "./text-area";
import { BaseFieldEditorComponent } from "../../base-field-editor.component";

@Component({
    selector: "textarea-editor",
    templateUrl: "./textarea-editor.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextareaEditorComponent extends BaseFieldEditorComponent implements OnInit, OnDestroy {
    constructor(_changeDetector: ChangeDetectorRef, private _formBuilder: FormBuilder) {
        super(_changeDetector);
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            placeholder: [this.textarea.placeholder],
        });
        super.onInit();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get textarea() {
        return this.field as Textarea;
    }
}
